export default __webpack_public_path__ + "static/media/icon_clear.52013779.svg";